<template>
  <section class="customers-list">
    <filters-form
      :initial="initial"

      :items="currentCustomers"
      :loading="currentLoading"
      :filters="currentFilters"

      :actions="actions"
      :per-page="initial.per_page"
    />

    <form-input
      v-model="searching"
      class="customers-list-search"
      icon="search"
      name="search"
      placeholder="Pesquisar..."
      :options="searchOptions"
      @input="searchCustomers"
    />

    <ul class="customers-list-items">
      <li
        v-for="customer in sorted"
        :key="customer.id"
      >
        <router-link
          :to="link(customer)"
          class="customers-list-link"
        >
          <typography-heading
            hierarchy="h3"
            :icon="sdk.mobile ? null : 'chevron-right'"
          >
            {{ customer.name | namelize }}

            <template v-slot:subtitle>
              #{{ customer.id }} - cadastrado dia {{ customer.created_at | createdAt }}
            </template>
          </typography-heading>

          <customer-list-item
            v-if="customer.phones.length || customer.emails.length"
            :customer="customer"
          />
        </router-link>

        <span class="customers-list-separator" />
      </li>

      <context-state
        :state="currentState"
        tag="li"
      >
        <template v-slot:loading>
          Carregando clientes...
        </template>

        <template v-slot:error>
          {{ currentError }}
        </template>

        <template v-slot:notfound>
          Nenhum cliente encontrado :(
        </template>
      </context-state>
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import invalidCPF, { CPF_FORMAT } from '@cordel/helpers/form/validators/cpf';
  import invalidCNPJ, { CNPJ_FORMAT } from '@cordel/helpers/form/validators/cnpj';
  // eslint-disable-next-line import/no-extraneous-dependencies
  import { INITIAL_CUSTOMER_FILTERS as INITIAL } from '@/store/modules/customers';
  // eslint-disable-next-line import/no-extraneous-dependencies
  import dataSort from '@/_CRUDL/helpers/data/sort';

  import FormInput from '@cordel/components/Form/Input.vue';
  import ContextState from '@cordel/components/Context/State.vue';
  import TypographyHeading from '@cordel/components/Typography/Heading.vue';
  import FiltersForm from '@sdk/components/Filters/Form.vue';
  import CustomerListItem from '@sdk/views/Customers/List/Item.vue';

  import mobile from '@sdk/helpers/interface/mobile';

  const INCOMPLETE = 'INCOMPLETE';
  const COMPLETE = 'COMPLETE';

  export default {
    name: 'CustomersList',
    components: {
      FormInput,
      ContextState,
      TypographyHeading,
      FiltersForm,
      CustomerListItem,
    },
    mixins: [
      mobile,
    ],
    data() {
      return {
        searching: '',
        searchingTimeout: null,

        searchingCPFCNPJ: false,

        count: 0,
        limit: false,

        initial: {},
        actions: {
          filter: 'customers/filter',
          clear: 'customers/clear',
          list: 'customers/list',
        },
      };
    },
    computed: {
      ...mapState([
        'customers',
      ]),

      currentCustomers() {
        return this.customers.list.items;
      },
      currentState() {
        const { error } = this.customers.list;

        if (this.searchingCPFCNPJ === INCOMPLETE) {
          return 'error';
        }

        if (this.currentLoading) {
          return 'loading';
        }

        if (error) {
          return 'error';
        }

        if (!this.sorted.length) {
          return 'notfound';
        }

        return 'empty';
      },
      currentError() {
        if (this.searchingCPFCNPJ === INCOMPLETE) {
          return 'Por favor, digite um CPF ou CNPJ válido';
        }

        return 'Algo deu errado! :(';
      },
      currentLoading() {
        return this.customers.list.loading;
      },
      currentFilters() {
        return this.customers.list.filters;
      },

      sorted() {
        if (this.searchingCPFCNPJ === INCOMPLETE) {
          return [];
        }

        return dataSort(this.currentCustomers, this.currentFilters.sort);
      },

      searchOptions() {
        if (!this.searchingCPFCNPJ) {
          return {};
        }

        return {
          mask: {
            format: CPF_FORMAT,
            bigFormat: CNPJ_FORMAT,
            type: 'patternize',
          },
        };
      },
    },
    beforeDestroy() {
      clearTimeout(this.searchingTimeout);
    },
    beforeMount() {
      const {
        search,
      } = this.$route.query;

      const initial = { ...INITIAL };

      if (!search) {
        this.initial = initial;

        return;
      }

      if (/\d/.test(search[0])) {
        if (invalidCPF(search) && invalidCNPJ(search)) {
          this.initial = initial;

          return;
        }
      }

      this.searching = search;
      this.initial = this.searchParameters(initial);
    },
    methods: {
      searchCustomers() {
        clearTimeout(this.searchingTimeout);
        this.searchingTimeout = setTimeout(this.searchingCustomers, 1000);
      },
      searchParameters(params) {
        /* eslint no-param-reassign: ['error', {
          props: true,
          ignorePropertyModificationsFor: ['params']
        }] */

        if (/\d/.test(this.searching[0])) {
          if (invalidCPF(this.searching) && invalidCNPJ(this.searching)) {
            this.searchingCPFCNPJ = INCOMPLETE;

            return params;
          }

          params.name = '';
          params.cpf_cnpj = this.searching;
          this.searchingCPFCNPJ = COMPLETE;
        } else {
          params.name = this.searching;
          params.cpf_cnpj = '';
          this.searchingCPFCNPJ = false;
        }

        return params;
      },
      searchingCustomers() {
        if (/\d/.test(this.searching[0])) {
          if (invalidCPF(this.searching) && invalidCNPJ(this.searching)) {
            this.searchingCPFCNPJ = INCOMPLETE;

            return;
          }
        }

        const params = this.searchParameters({
          name: '',
          cpf_cnpj: '',
          page: 1,
          CRUDL_append: false,
        });

        this.$store
          .dispatch(this.actions.filter, params)
          .then(this.searchedCustomers);
      },
      searchedCustomers() {
        this.$store.dispatch(this.actions.list, this.currentFilters);
      },

      link(customer) {
        return {
          name: 'customers-read-informations',
          params: {
            id: customer.id,
          },
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .customers-list-search {
    margin: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }

  .customers-list-items {
    list-style: none;
    margin-top: var(--cordel-spacing-xl);
    overflow: hidden;
  }

  .customers-list-link {
    display: block;
    padding: var(--cordel-spacing-xl) var(--product--pwa--horizontal);

    &:hover {
      background: var(--cordel-color-neutral-lighter);
    }

    &:focus {
      box-shadow: inset 0 0 0 var(--cordel-border-width-thin) var(--cordel-color-highlight-primary);
      outline: none;
    }

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: var(--cordel-spacing-xl) var(--product--pwa--horizontal);
    }
  }

  .customers-list-separator {
    background-color: var(--cordel-color-neutral-dark);
    display: block;
    height: var(--cordel-border-width-soft);
    margin: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }
</style>
